import { createFileRoute } from '@tanstack/react-router';

import { DocumentsPage } from '@/features/project-documents/documents-page';

export const Route = createFileRoute('/_app/projects/$projectId/documents')({
  component: Documents,
});

function Documents() {
  const { projectId } = Route.useParams();
  return <DocumentsPage projectId={projectId} />;
}
